module.exports = __webpack_public_path__ + "img/2022_michigan.ba092e58.jpg";